module.exports = __webpack_public_path__ + "static/media/header.44ad0f97.jpg";